module.exports = __webpack_public_path__ + "img/speaker-GogiGvakharia.aa73dfa2.png";